module.exports = __webpack_public_path__ + "static/media/logo_grayscale.f26e2483.png";